// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M2.81 5.2L7 8 11.19 2.14A1 1 0 0 1 12.82 2.14L17.01 8 21.21 5.2A1 1 0 0 1 22.76 6.15L21.11 20.12A1 1 0 0 1 20.12 21H3.89A1 1 0 0 1 2.9 20.12L1.26 6.15A1 1 0 0 1 2.81 5.2M12.01 15A2 2 0 1 0 12.01 11 2 2 0 0 0 12.01 15"/>';

/** Crown (rewards). */
const icon: IconData = {
  id: "crown",
  name: "Crown",
  category: "rewards",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path d="M3.5 8.06L4.78 19H19.22L20.51 8.06 16.5 10.73 12 4.43 7.5 10.73ZM2.81 5.2L7 8 11.19 2.14A1 1 0 0 1 12.82 2.14L17.01 8 21.21 5.2A1 1 0 0 1 22.76 6.15L21.11 20.12A1 1 0 0 1 20.12 21H3.89A1 1 0 0 1 2.9 20.12L1.26 6.15A1 1 0 0 1 2.81 5.2M12.01 15A2 2 0 1 1 12.01 11 2 2 0 0 1 12.01 15"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M12.46 1.83L12.82 2.14 17.01 8 21.21 5.2 21.75 5.03 22.29 5.18 22.67 5.59 22.76 6.15 21.11 20.12 21 20.47 20.78 20.75 20.48 20.93 20.12 21H3.89L3.53 20.93 3.23 20.75 3.01 20.47 2.9 20.12 1.26 6.15 1.35 5.59 1.73 5.18 2.27 5.03 2.81 5.2 7 8 11.19 2.14 11.55 1.83 12.01 1.72Z"/></g><path d="M3.5 8.06L4.78 19H19.22L20.51 8.06 16.5 10.73 12 4.43 7.5 10.73ZM2.81 5.2L7 8 11.19 2.14A1 1 0 0 1 12.82 2.14L17.01 8 21.21 5.2A1 1 0 0 1 22.76 6.15L21.11 20.12A1 1 0 0 1 20.12 21H3.89A1 1 0 0 1 2.9 20.12L1.26 6.15A1 1 0 0 1 2.81 5.2M12.01 15A2 2 0 1 1 12.01 11 2 2 0 0 1 12.01 15"/>',
    },
  },
  animation: () => import("../animations/crown.js"),
};

export default icon;
